import { render, staticRenderFns } from "./heavyCargo.vue?vue&type=template&id=7072108d&scoped=true&"
import script from "./heavyCargo.vue?vue&type=script&lang=js&"
export * from "./heavyCargo.vue?vue&type=script&lang=js&"
import style0 from "./heavyCargo.vue?vue&type=style&index=0&id=7072108d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072108d",
  null
  
)

component.options.__file = "heavyCargo.vue"
export default component.exports